import Ajax from '@utils/ajax';

export default {
  group(options = {}) {
    return Ajax.get({
      url: '/config?group=1',
      ...options,
    });
  },

  user(options = {}) {
    return Ajax.get({
      url: '/config',
      ...options,
    });
  },
};
